import React, { useId } from 'react'

export default function ToggleCheckbox({ label, style, ...props }) {
  const id = useId()

  return (
    <div className="dome-d-flex dome-align-center dome-gap3">
      <input id={id} type="checkbox" style={{ accentColor: 'black', margin: 0, padding: 0, ...style }} {...props} />
      {label && <label htmlFor={id}>{label}</label>}
    </div>
  )
}
